// @ts-check
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/selectFileSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from "mobx-react";
import React from "react";

/**
 * @param {{
 * id: string,
 * className?: string,
 * title?: string,
 * helperText?: string,
 * selectedFileName: string | null | undefined
 * selectionTitle: string,
 * accept: string,
 * onFileSelected: (arg0: File | null) => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const SelectFileSetting = (props) => {
    const inputId = props.id + '_input';
    const buttonId = props.id + '_button';
    const clearId = props.id + '_clear';

    return (
        <div className={'setting-container select-file-setting ' + (props.className ? props.className : '')}>

            {
                props.title ?
                    <div className='setting-title select-file-setting-title'>
                        {props.title}
                        {props.helperText ?
                            <Popup
                                popupText={props.helperText}
                                className='fast-info-popup'>
                                {IconsContainer.Get('ci-info')}
                            </Popup>
                            : ''}
                    </div>
                    : ''
            }

            <div className='select-file-setting-value'>
                <input
                    id={inputId}
                    type="file"
                    className="select-file-setting-input"
                    accept={props.accept}
                    onChange={e => {
                        let file = e.target.files?.item(0);
                        if (!file)
                            return;

                        props.onFileSelected(file);
                    }} />

                {
                    props.selectedFileName
                        ?
                        <div className="select-file-setting-file">
                            <div
                                className='select-file-setting-file-name'
                                title={props.selectedFileName}>
                                {props.selectedFileName}
                            </div>
                            <button
                                id={clearId}
                                className="select-file-setting-clear"
                                onClick={() => {
                                    let input = document.getElementById(inputId)
                                    if (input instanceof HTMLInputElement)
                                        input.value = '';

                                    props.onFileSelected(null);
                                }}>
                                {IconsContainer.Get('ci-cross')}
                            </button>
                        </div>
                        :
                        <button
                            id={buttonId}
                            className="select-file-setting-button"
                            onClick={() => document.getElementById(inputId)?.click()}>
                            {props.selectedFileName
                                ? props.selectedFileName
                                : props.selectionTitle}
                        </button>
                }

            </div>
        </div>
    )
}

export default observer(SelectFileSetting);